import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useSetFlowVersion = (flowId) => {
  const dispatch = useDispatch();
  const orgId = useSelector(state => state.session.user.primaryOrganization.organization.ID);
  const {
    isLoading, isError, isSuccess, mutate, reset,
  } = useMutation(
    ['set-flow-version', orgId, flowId],
    async ({ version, ...payload }) => (
      axiosInstance.put(flow(orgId).setFlowVersion(flowId, version), payload)
    ),
    {
      onSuccess: () => (
        dispatch(showAlert({ message: 'Flow current version has been updated.', type: 'success' }))
      ),
      onError: (error) => dispatch(showAlert({ message: error.response.data.message, type: 'error' })),
    },
  );
  return {
    isLoading, isError, isSuccess, mutate, reset,
  };
};
